var r = 0;
function u(u) {
  var a = ++r + "";
  return u ? u + a : a;
}
export { u as default };